import _ from 'lodash'

export default {
  getThemeColor(state: any) {
    return _.get(state, 'main.color', 'black');
  },
  isOnline(state: any) {
    return _.get(state, 'isOnline', true);
  },
  getScannerValue(state: any): string {
    return _.get(state, 'scanner.value.value', '');
  },
  getScanIndex(state: any): number {
    return _.get(state, 'scanner.value.i', 0);
  },
  isScannerConnected(state: any): boolean {
    return _.get(state, 'scanner.connected', false);
  },
};
